import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Services from '@/pages/Services'
import ServiceDetail from '@/pages/ServiceDetail'
import Contact from '@/pages/Contact'
import Blog from '@/pages/Blog'
import BlogDetail from '@/pages/BlogDetail'
import Careers from '@/pages/Careers'
import NotFound from '@/pages/NotFound'
import { useRoutes } from 'react-router-dom'
import { LanguageProvider } from '@/context/LanguageContext'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/sobre', element: <About /> },
  { path: '/servicos', element: <Services /> },
  { path: '/servicos/:slug', element: <ServiceDetail /> },
  { path: '/contato', element: <Contact /> },
  { path: '/blog', element: <Blog /> },
  { path: '/blog/:slug', element: <BlogDetail /> },
  { path: '/carreiras', element: <Careers /> },
  { path: '*', element: <NotFound /> },
]

function AppRoutes() {
  return useRoutes(routes)
}

function App() {
  return (
    <LanguageProvider>
      <AppRoutes />
    </LanguageProvider>
  )
}

export default App
